export var LOCALES = {
    DE: 'de',
    EN: 'en',
    ES: 'es',
    FR: 'fr',
    HE: 'he',
    IT: 'it',
    JA: 'ja',
    KO: 'ko',
    NL: 'nl',
    PT: 'pt',
    RU: 'ru',
    TR: 'tr',
    UK: 'uk',
};
export var SUPPORT_DOMAIN = 'support.wix.com';
//# sourceMappingURL=constants.js.map